
// Vendor Dependencies
import './vendor/swal.min.js';

import './_confirm-link.js';
import './_confirm-form.js';
import './_confirm-select.js';

